<div [class]="skinName">
  <div class="account-container mobile-none">
    <!-- profile management UI start-->
    @if (enableProfiles) {
      <div class="container p-0">
        <div class="profile-detail">
          <div class="lt-div">
            @if (profileInfo?.icon) {
              <div class="profile-pic"><img src="{{imagePath + profileInfo.icon}}"></div>
              } @else {
              <div class="profile-pic"> {{((profileInfo?.name).charAt(0)).toUpperCase()}} </div>
              }
              <div class="profile-info">
                <div class="profile-title">{{(configService?.localeKeys?.['account.hi.text'] || 'Hi') + ' ' + profileInfo?.name}} </div>
                <div class="manage-profiles-btn" (click)="manageProfile()"><img class="prof-setting-img" src="/branding/theme/assets/static_assets/ic-settings-manage-profile.svg"> {{configService?.localeKeys?.['account.manage_profile.button'] || 'Manage Profiles'}}</div>
              </div>
          </div>
          <div class="rt-btn">
            <button class="switch-profile-btn" (click)="switchToAnotherProfile()" ><img src="/branding/theme/assets/static_assets/ic-switch-profile-on-lbg.svg"> {{configService?.localeKeys?.['account.switch_profile.button'] || 'Switch Profile'}}</button>
          </div>
        </div>
      </div>
    }
    <!-- profile management UI end -->

    <div class="head-content">
      @if (myAccountData && userSubscription !== 1 && !isVoucherSuspended) {
        <app-activate-user [page]="'account'"></app-activate-user>
      }
      <h3 class="container"> {{ configService.localeKeys?.['menu.my_account.text'] }}
      </h3>
    </div>
    <div class="container personal-info partition">
      <h4>{{ configService.localeKeys?.['account.personal_info.text'] }}</h4>
      <div class="personal-details">
        <div class="detail">
          <span class="dt-field">{{ configService.localeKeys?.['my_account.edit_name.text'] }}</span>
          <span class="dt-value">{{ userName }}</span>
          <div class="dt-btn rt-btn dt-btn-edit-icon">
            <span class="edit-icon"></span>
            <button (click)="openUikitDialog('#edit-account')" class="edit-btn-icon">{{ configService.localeKeys?.['account.edit.text'] }}</button>
          </div>
        </div>
        <div class="detail">
          <span class="dt-field">{{ configService.localeKeys?.['common_keys.email.text'] }}</span>
          <span class="dt-value" [innerHTML]="userEmail || '-'"><button class="check-icon icon-btn"></button></span>
          <!-- <div class="dt-btn rt-btn">
          <button (click)="openUikitDialog('#edit-email')">{{ configService.localeKeys?.['account.edit.text'] }}</button>
        </div> -->
      </div>
      @if (userLoginBy == 'manual' && (userIntegrationType !== 'api' && userIntegrationType !== 'sso' && userIntegrationType !== 'ftp' && userIntegrationType !== 'soap') ) {
        <div class="detail" >
          <span class="dt-field">{{ configService.localeKeys?.['common_keys.password.text'] }}</span>
          <span class="dt-value">*********</span>
          <div class="dt-btn rt-btn">
            <button (click)="openUikitDialog('#change-password')">{{ configService.localeKeys?.change_title }}</button>
          </div>
        </div>
      }
      <div class="detail">
        <span class="dt-field">{{ configService.localeKeys?.['account.phone_number.text'] }}</span>
        <span class="dt-value"> {{userNumber ? ((myAccountData?.user_phone_code && userPhoneCodeObj?.login_with_mobile_enabled && settingsService?.loginWithMobileEnabled ? '+' + myAccountData?.user_phone_code + ' ' : '') + userNumber) : '-'}}
          @if (userPhoneCodeObj?.phone_code && settingsService?.loginWithMobileEnabled && myAccountData.user_mobile_verified == 1 && userNumber) {
            <span class="dt-check"></span>
          }
        </span>
        <div class="dt-btn rt-btn dt-btn-edit-icon">
          @if (userNumber) {
            <span class="edit-icon"></span>
          }
          <button (click)="openUikitDialog('#change-phone')">{{userNumber ? (configService.localeKeys['account.edit.text'] || 'Edit') : ('+' + (configService.localeKeys['my_acc_per_info_add_btn'] || 'Add')) }} </button>
        </div>
      </div>
      <div class="detail">
        <span class="dt-field">{{ configService.localeKeys?.['account.user_id.text']}}</span>
        <span class="dt-value">{{ userId }}</span>
        <div class="dt-btn">
        </div>
      </div>
      <!-- only for tvod based project-->
      @if (!settingsService?.isSvodEnabled && settingsService.isTvodEnabled) {
        <div class="detail">
          <span class="dt-field">{{ 'Transactions'}}</span>
          <span class="dt-value">{{ 'Rentals and Purchases' }}</span>
          <div class="dt-btn rt-btn" (click)="navigateToBillingHistory()">
            <button (click)="openUikitDialog('#change-password')">{{configService.localeKeys?.['account.billing_history.text']}}</button>
          </div>
        </div>
      }
      @if (userTelco) {
        <div class="detail">
          <span class="dt-field"></span>
          <span class="dt-value">({{configService.localeKeys?.['account.support_desk_email.text']}})</span>
          <div class="dt-btn">
          </div>
        </div>
      }
    </div>
  </div>

  @if (settingsService.isSvodEnabled == 1 && plansLength) {
    <div id="accountPagePlans" class="partition plans container">
      <h4>{{ configService.localeKeys?.['account.plan_billing.text'] }}</h4>
      <div class="payment-details">
        @if (subscribedPlan && subscribedPlan?.cancel_subscription == '1') {
          <div id="cancel-info">
            <span id="cancel-text">
              {{ subscribedPlan?.subscription_text }}
            </span>
            <button (click)="openUikitDialog('#change-subscription')" id="select-plan">
              {{configService.localeKeys?.['plans.choose_plan.text'] || 'Choose a Plan'}}
            </button>
          </div>
        }
        <!-- if not subscribed using either voucher or card or inapp -->
        @if (myAccountData.is_subscription_applied == 0 && myAccountData.is_voucher_applied == 0 && myAccountData.voucher.is_voucher_suspended != 1&& userTelco == '') {
          <div class="detail">
            <span class="dt-value extra-info">
              <!-- {{ configService.localeKeys.['account.no_active_subs_or_voucher.text'] }} -->
              <span class="plan-text"> {{ configService.localeKeys?.['common_keys.plan.text'] || 'Plan'}} </span>
              <span class="plans-dash">-</span>
            </span>
            @if (settingsService.isSvodEnabled == 1 && myAccountData.user_type == 0) {
              <div class="chooseplan dt-btn rt-btn">
                <span class="choosetext">{{(configService.localeKeys?.pymnt_popup_part1 || 'Starting from') + ' '}}</span>
                <span class="choosetext-suffix">{{planService.planDetail}}</span>
                <button class="choosebtn" (click)="openUikitDialog('#choose-subscription')">
                  {{ configService.localeKeys?.['plans.choose_plan.text'] ||'Choose'}}
                </button>
              </div>
            }
          </div>
        }
        @if (myAccountData.is_subscription_applied == 0 && myAccountData.is_voucher_applied == 0 && userTelco == '' && userPaymentData.payment_mode != 'voucher') {
          <div class="detail">
            <span class="dt-value extra-info">
              <span class="plan-text">{{ configService.localeKeys?.['account.payment_info.text'] || 'Payment info'}}</span>
              <span class="plans-dash">-</span>
            </span>
          </div>
        }
        <!-- end if -->
        <!-- if user is subscribed using card -->
        @if (myAccountData.is_subscription_applied == '1' && myAccountData.is_voucher_applied == 0 && userPaymentData.payment_provider !== 'inapp' && userTelco == '') {
          <div class="detail">
            <span class="dt-field">{{ configService.localeKeys?.['common_keys.plan.text'] }}</span>
            <span class="dt-value">{{ subscriptionTitle }}&nbsp;
              <span class="post-divider-text">{{ subscriptionAmount }}</span>
            </span>
            @if (plansLength > 1 && (subscribedPlan?.cancel_subscription == 0 || !subscribedPlan?.cancel_subscription)) {
              <div class="dt-btn rt-btn">
                <button (click)="openUikitDialog('#change-subscription')">
                  {{ configService.localeKeys?.change_title || 'Change'}}
                </button>
              </div>
            }
            @if ((subscribedPlan?.cancel_subscription == 1 || subscribedPlan?.cancel_subscription) ) {
              <div class="dt-btn rt-btn">
                <button (click)="openUikitDialog('#change-subscription')">
                  {{ configService.localeKeys?.['plans.resume_subscription.text'] || 'Resume Subscription'}}
                </button>
              </div>
            }
          </div>
        }
        @if (myAccountData.is_subscription_applied == '1' && myAccountData.is_voucher_applied == 0 && userPaymentData.payment_provider !== 'inapp') {
          <div class="detail">
            <span class="dt-field">{{configService.localeKeys?.['account.payment_info.text']}}</span>
            <span class="dt-value">{{ userPaymentData.payment_mode }}
              <!-- <button class="visa-icon icon-btn"></button> -->
            </span>
            @if(userPaymentData.payment_mode != "free-plan"){
              <div class="dt-btn rt-btn">
                <button (click)="openUikitDialog('#change-payment-info')">{{ configService.localeKeys?.['account.edit.text'] }}</button>
              </div>
            }
          </div>
        }
        @if (myAccountData.is_subscription_applied == '1' && myAccountData.is_voucher_applied == 0 && userPaymentData.payment_provider !== 'inapp') {
          <div class="detail">
            <span class="dt-field">{{ configService.localeKeys?.['account.next_billing_date.text'] }}</span>
            <span class="dt-value">{{ userPaymentData.next_due_date }}</span>
            <div class="dt-btn">
              <!-- <button>{{ configService.localeKeys?.change_title }}</button> -->
            </div>
          </div>
        }
        <!-- end if -->
        <!-- if user is subscribed using voucher -->
        @if (myAccountData.is_voucher_applied == 1 && !myAccountData?.voucher?.is_voucher_suspended) {
          <div class="detail">
            <span class="dt-field">{{ configService.localeKeys?.['account.voucher_code.text'] }}</span>
            <span class="dt-value">{{ myAccountData.voucher.voucher_code }}</span>
            <div class="dt-btn">
              <!-- <button uk-toggle="target: #change-phone">{{ configService.localeKeys?.change_title }}</button> -->
            </div>
          </div>
        }
        @if (myAccountData.is_voucher_applied == 1 && myAccountData.user_telco == '' ) {
          <div class="detail">
            <span class="dt-field">{{ configService.localeKeys?.['account.expiry_date.text'] }}</span>
            <span class="dt-value">{{ myAccountData.voucher.expiry_date }}</span>
            <div class="dt-btn">
              <!-- <button uk-toggle="target: #change-phone">{{ configService.localeKeys?.change_title }}</button> -->
            </div>
          </div>
        }
        <!-- if user is suspendend using voucher -->
        @if (myAccountData.voucher.is_voucher_suspended && userPaymentData.payment_mode == 'voucher') {
          <div>
            <div class="redribon">
              <span class="suspendend-value">
                {{configService.localeKeys?.acc_suspended_cont_oprtr_part1}} "{{myAccountData.user_telco}}" {{configService.localeKeys?.acc_suspended_cont_oprtr_part2}}
              </span>
            </div>
            <div class="detail" >
              <span class="dt-field plan-text">{{ configService.localeKeys?.['account.payment_info.text'] || 'Payment info'}}</span>
              <span class="extra-info">
                <span class="voucher-text">{{myAccountData.user_telco}}</span>
                <span class="suspendend-text">{{configService.localeKeys?.acc_telco_managed_info_part1+ " " + myAccountData.user_telco + " " + configService.localeKeys?.acc_telco_managed_info_part2 }}</span>
              </span>
            </div>
          </div>
        }
        <!-- end if voucher -->
        <!-- voucher edit feature -->
        <!-- <div class="detail">
        <span class="dt-field empty-voucher-field"></span>
        <span class="dt-value voucher-value"><button class="icon-btn gift-card-icon"></button>Voucher / &nbsp; <span class="post-divider-text">50% Discount for 3 months</span></span>
        <div class="dt-btn">
          <button uk-toggle="target: #voucher-change">{{ configService.localeKeys?.['account.edit.text'] }}</button>
        </div>
      </div>
      <div class="detail">
        <span class="dt-value voucher-info">
          Your Voucher will be valid until April 30, 2021. After that, you'll be charged 17.90 TL monthly.
        </span>
      </div> -->
      <!-- end voucher edit feature -->
      <!-- if user is subscribed using telco -->
      @if (userTelco !== '' && myAccountData.voucher.is_voucher_suspended != 1) {
        <div class="detail">
          <span class="dt-field">{{configService.localeKeys?.['account.payment_info.text']}}</span>
          <span class="dt-value">{{ userPaymentData.payment_info_text }}
            <!-- <button class="visa-icon icon-btn"></button> -->
          </span>
        </div>
      }
      <!-- end if telco-->
      <!-- if user is subscribed using inapp purchases -->
      @if (myAccountData.is_subscription_applied == 1 && userPaymentData.payment_provider == 'inapp') {
        <div class="detail">
          <span class="dt-field">{{ configService.localeKeys?.['common_keys.plan.text'] }}</span>
          <span class="dt-value">{{ subscriptionTitle }}&nbsp;
            <span class="post-divider-text">{{ subscriptionAmount }}</span>
          </span>
        </div>
      }
      @if (myAccountData.is_subscription_applied == 1 && userPaymentData.payment_provider == 'inapp') {
        <div class="detail">
          <span class="dt-field">{{configService.localeKeys?.['account.payment_info.text']}}</span>
          <span class="dt-value">{{ userPaymentData.payment_info_text }}</span>
        </div>
      }
      @if (myAccountData.is_subscription_applied == 1 && userPaymentData.payment_provider == 'inapp') {
        <div class="detail">
          <span class="dt-field">{{ configService.localeKeys?.['account.next_billing_date.text'] }}</span>
          <span class="dt-value">{{ userPaymentData.next_due_date }}</span>
          <div class="dt-btn rt-btn">
            <!-- <button>{{ configService.localeKeys?.change_title }}</button> -->
          </div>
        </div>
      }
      <!--end if inapp -->
      @if ((userTelco == '' && userPaymentData.payment_mode !='voucher') || settingsService.isTvodEnabled) {
        <div class="detail">
          <span class="dt-field"></span>
          <span class="dt-value"></span>
          <div class="dt-btn rt-btn">
            <button (click)="navigateToBillingHistory()">{{configService.localeKeys?.['account.billing_history.text']}}</button>
          </div>
        </div>
      }
      @if (myAccountData.voucher.is_voucher_suspended != 1) {
        <div class="detail gift-detail">
          <div class="gift-voucher-btn">
            @if (myAccountData?.user_telco == '' && (!myAccountData?.user_type || (myAccountData?.user_type && myAccountData?.is_voucher_applied == 1  )) ) {
              <span class="gift-detailbtn" (click)="openUikitDialog('#redeem-voucher-screen')">
                <div class="gift-card-icon"></div>
                <span>{{ configService.localeKeys?.['account.redeem_code.text'] }}</span>
              </span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
<div class="partition settings container">
  <h4>{{ configService.localeKeys?.['account.settings.text']}}</h4>
  <div class="settings-details">
    <!-- <div class="infobox-cardbg">
    <span class="">
      For a better experience we'd love to contact you. To do so, we need your approval of our Communication Policy.
    </span>
    <div class="rt-btn">
      <button class="p-0 dt-btn-w">See Details</button>
    </div>
  </div> -->
  <!-- above infobox-cardbg section can be swapped with infobox-info, infobox-brand -->

  <!-- <div class="detail">
  <div class="dt-btn w-100">
    <button class="p-0">{{ configService.localeKeys?.communication_preferences }}</button>
  </div>
</div> -->
@if (settingsService.parentalControlModuleEnabled && parentalControl.age_limits.length > 0) {
  <div class="detail">
    @if ((!parentalControl.is_parental_control_enabled)) {
      <div class="dt-btn w-100">
        <button class="p-0" (click)="setAgeParentPin()" (click)="openUikitDialog('#parental-control-modal')">{{ configService.localeKeys?.['common_keys.parental_control.text'] }}</button>
      </div>
    } @else {
      <div id="pin-control-edit">
        <span id="pin-title">{{ configService.localeKeys?.['common_keys.parental_control.text'] }}</span>
        <span id="pin-detail">{{configService.localeKeys?.pin_set_for_age_information_part1 }} {{ageLimitTitle}} {{configService.localeKeys?.['common_keys.contents.text']}}</span>
        <div class="pin-edit-block">
          <span class="edit-icon"></span>
          <button class="p-0" (click)="setAgeParentPin()" id="pin-edit" (click)="openUikitDialog('#parental-control-modal')">{{configService.localeKeys?.['account.edit.text']}}</button>
        </div>
      </div>
    }
  </div>
}
<!-- <div class="detail">
<div class="dt-btn w-100">
  <button class="p-0">{{ configService.localeKeys?.communication_preferences }}</button>
</div>
</div> -->
@if (settingsService.activateYourTvFromTVCode) {
  <div class="detail" >
    <div class="dt-btn w-100">
      <button class="p-0" (click)="openUikitDialog('#activate-tv-modal')">{{ configService.localeKeys?.activate_new_devices }}</button>
    </div>
  </div>
}
@if (settingsService.activateYourTvFromWebCode) {
  <div class="detail" >
    <div class="dt-btn w-100">
      <button class="p-0" (click)="activeTvRoute()">{{ configService.localeKeys?.activate_new_devices }}</button>
    </div>
  </div>
}
@if (locales.length > 1) {
  <div class="detail">
    <div class="dt-btn w-100">
      <button class="p-0" (click)="openUikitDialog('#change-language')">{{configService.localeKeys?.['change_language.change_language.text']}}</button>
    </div>
  </div>
}
<div class="detail">
  <div class="dt-btn w-100">
    <button class="p-0" (click)="openUikitDialog('#manage-devices');showDevice() ">{{ configService.localeKeys?.['common_keys.manage_all_devices.text'] }}</button>
  </div>
</div>
<button class="p-0 display-none" id="ideal_pay_success_btn" (click)="openUikitDialog('#ideal_pay_redirect_model')"></button>
</div>
</div>
@if (settingsService.feedbackEnabled) {
  <div class="container feedback">
    <div>{{configService.localeKeys?.bug_or_suggestion}} <a (click)="openUikitDialog('#feedback-screen')">{{ configService.localeKeys?.give_feedback_title }}</a></div>
    @if (myAccountData.is_subscription_applied == 1 && subscribedPlan && subscribedPlan?.cancel_subscription == '0' && userPaymentData.payment_provider !== 'inapp' && userTelco == '') {
      <div>
        {{ configService.localeKeys?.cancel_subscription_anytime_part1 }}
        <a (click)="settingsService.churnPreventionFlowEnabled ?churnRoute() : openUikitDialog('#cancel-subscription')">
        {{configService.localeKeys?.['plans.cancel_subscription.text']}}</a>
      {{configService.localeKeys?.cancel_subscription_anytime_part3}}</div>
    }
  </div>
}
<div class="container sign-out">
  <button (click)="logout()" class="btn btn-lg rounded-0">{{ configService.localeKeys?.['common_keys.sign_out.btn'] }}</button>
</div>
<!--
<div id="change-name" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical" style="width: 431.6px !important;">
    <button class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
    <h2 class="uk-modal-title">
    Edit Your Personal Info</h2>
    <p>You may edit your name and surname below.</p>
    <app-change-name></app-change-name>
  </div>
</div> -->
<div id="change-password" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button id="change-password-hide" class="uk-modal-close-default uk-close-large" type="button" uk-close>
      <!-- <img src="branding/theme/assets/static_assets/model-close.svg" alt="close icon"> -->
    </button>
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.edit_info_title }}</h2>
    <p>{{ configService.localeKeys?.edit_password_description }}</p>
    <app-change-password></app-change-password>
  </div>
</div>
<!-- <div id="edit-email" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
<div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
  <button class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
  <app-change-email [existedEmail]= "userEmail"></app-change-email>
</div>
</div> -->
@if (openModelName === '#change-phone') {
  <div id="change-phone" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      <button class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
      <app-change-phone [phoneNumber]="userNumber" [userTelco]="userTelco" (updateAccountData)="getAccountEventReciever()"></app-change-phone>
    </div>
  </div>
}
<div id="activate-tv-modal" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
    <app-activate-tv-modal></app-activate-tv-modal>
  </div>
</div>
<div id="change-language" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.['change_language.change_language.text'] }}</h2>
    <p>{{ configService.localeKeys?.['change_language.select_prefered_language.desc'] }}</p>
    <app-change-language></app-change-language>
  </div>
</div>
<div id="manage-devices" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default uk-close-large" type="button" uk-close (click)="closeEditAlso()"></button>
    @if(!hideDevice){
    <app-manage-devices ></app-manage-devices>
    }
  </div>
</div>

@if (settingsService.feedbackEnabled && openModelName === '#feedback-screen') {
<div id="feedback-screen" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.['feedback.feedback.text'] }}</h2>
    <p class="para-width">
      {{ configService.localeKeys?.['user_feedback.bug_or_suggestion.text']}}
    </p>
    <app-feedback></app-feedback>
  </div>
</div>
}

@if (openModelName === '#change-subscription') {
  <div id="change-subscription" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false; stacked: true; cls-page: 'acc-modal-page';">
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      <button class="uk-modal-close-default uk-close-large" type="button" id="close-event" (click)="onPaymentPopUpClose()" uk-close></button>
      @if (planData) {
        <div>
          <app-change-plan (newItemEvent)="updateDataAfterChild($event)" [planData]="planData" [page]="'account'" #ChangePlan></app-change-plan>
        </div>
      }
    </div>
  </div>
}
@if (openModelName === '#choose-subscription') {
  <div id="choose-subscription" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false; stacked: true; cls-page: 'acc-modal-page';">
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      <button class="uk-modal-close-default uk-close-large" type="button" id="close-event" uk-close (click)="onPaymentPopUpClose()"></button>
      @if (planData) {
        <div>
          <app-model-payment [page]="'account'" [planData]="planData" (newItemEvent)="updateDataAfterChild($event)" #ModelPayment></app-model-payment>
        </div>
      }
    </div>
  </div>
}
<div id="change-payment-info" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false; stacked: true">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default uk-close-large" type="button" (click)="close_ideal_pay_model()" uk-close></button>
    <app-change-payment-info  (newItemEvent)="updateDataAfterChild($event)"></app-change-payment-info>
  </div>
</div>
<div id="cancel-subscription" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false; stacked: true;">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default uk-close-large" type="button" (click)="updateAfterCancel()" uk-close></button>
    @if (subscribedPlan) {
      <app-cancel-sub [page]="'account'" [userDataChild] = 'userDataChild' (newItemEvent)="updateDataAfterChild($event)" [subscribedPlan]="subscribedPlan"></app-cancel-sub>
    }
  </div>
</div>
@if (openModelName === '#edit-account') {
  <div id="edit-account" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false; stacked: true;">
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      <button id="edit-close" class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
      <app-edit-account (newItemEvent)="updateDataAfterChild($event)" [page]="'account'" [userDataChild] = 'userDataChild'></app-edit-account>
    </div>
  </div>
}
<div id="redeem-voucher-screen" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false; stacked: true;">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
    <app-redeem-voucher-screen (newItemEvent)="updateDataAfterChild($event)" [myAccountData]="myAccountData" #RedeemVoucher></app-redeem-voucher-screen>
  </div>
</div>
@if (settingsService.parentalControlModuleEnabled) {
  <div id="parental-control-modal" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false; stacked: true;">
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      <button id="pin-close" (click)="pinCloseControl()" class="uk-modal-close-default uk-close-large" type="button" uk-close></button>
      <app-parental-control #ParentalPin [parentalControl]="parentalControl" (updateAccountData)="getAccountEventReciever()"></app-parental-control>
    </div>
  </div>
}
<div id="ideal_pay_redirect_model" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false; stacked: true;">
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <button class="uk-modal-close-default uk-close-large" (click)="close_ideal_pay_model()" type="button" uk-close></button>
    @if (toptext) {
      <h2 class="uk-modal-title mobile-none">
      {{ configService.localeKeys?.['voucher.voucher_activated.text'] }}</h2>
    }
    <app-success [redeemWatchBtn]="true"  [toptext]="toptext" icon="/branding/theme/assets/static_assets/ic-success.svg" [bottomtext]="bottomText" [haslottie]="'true'">
    </app-success>
  </div>
</div>
</div>

</div>